import { Component, Inject, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslocoPipe } from '@ngneat/transloco';
import { DrakeFilePreviewComponent } from "../drake-file-preview/drake-file-preview.component";

@Component({
  selector: 'app-file-preview-dialog',
  templateUrl: './file-preview-dialog.component.html',
  styleUrls: ['./file-preview-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    HttpClientModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatDialogModule,
    TranslocoPipe,
    DrakeFilePreviewComponent 
],
providers:[TranslocoPipe]
})
export class FilePreviewDialogComponent implements OnInit, OnChanges {
  public file: any;
  audioSrc: SafeResourceUrl | null = null;
  fileUrl: SafeResourceUrl | null = null;
  fileType: string | null = null;
  fileName: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<FilePreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer
  ) {
    this.file = this.data.file;
    this.fileUrl = this.file.dataUrl;
    this.fileName = this.file.fileName;

  }

  ngOnInit(): void {
    this.updateFileData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.updateFileData();
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  updateFileData(): void {
    if (this.file) {
      if (this.isAudioFile(this.file.fileName)) {
        this.audioSrc = this.sanitizer.bypassSecurityTrustUrl(this.file.dataUrl);
      } else {
        this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.file.dataUrl);
      }
      this.fileType = this.file.contentType;
    }
  }

  isAudioFile(fileName: string): boolean {
    const audioExtensions = ['mp3', 'wav', 'ogg', 'flac'];
    const fileExtension = fileName.split('.').pop().toLowerCase();
    return audioExtensions.includes(fileExtension);
  }
  isImageFile(fileName: string): boolean {
    return /\.(jpg|jpeg|png|gif)$/i.test(fileName);
  }

  isPdfFile(fileName: string): boolean {
    return /\.pdf$/i.test(fileName);
  }

  isVideoFile(fileName: string): boolean {
    return /\.(mp4|mov|avi)$/i.test(fileName);
  }

}
